const SECTIONS = [
  {
    title: 'Before tutor approval',
    body: 'When you submit a booking request, you are not charged. Payment is only processed after the tutor accepts your session(s).',
  },
  {
    title: 'Cancellation & rescheduling',
    body: 'You may cancel or reschedule up to 24 hours before a confirmed session start time. Cancellations within 24 hours may not be eligible for a refund.',
  },
  {
    title: 'Refunds after payment',
    body: 'If a confirmed session is cancelled by you (within policy) or by the tutor, eligible refunds are returned to your original payment method or issued as account credit, as determined by Tutor Scene.',
  },
  {
    title: 'Processing time',
    body: 'Approved refunds typically appear within 5–10 business days, depending on your bank or card issuer.',
  },
];

const RefundPolicyPage = () => (
  <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6">
    <h1 className="text-3xl font-bold text-brand-deep-navy">Refund Policy</h1>
    <p className="mt-3 text-gray-600">
      This policy explains how refunds work for tutoring sessions booked through Tutor Scene.
    </p>

    <div className="mt-8 space-y-6">
      {SECTIONS.map((section) => (
        <section
          key={section.title}
          className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm"
        >
          <h2 className="text-lg font-semibold text-brand-dark-blue">{section.title}</h2>
          <p className="mt-2 text-sm leading-relaxed text-gray-700">{section.body}</p>
        </section>
      ))}
    </div>

    <p className="mt-8 text-sm text-gray-600">
      Questions? Contact us through the platform support channels listed on our website.
    </p>
  </div>
);

export default RefundPolicyPage;
